export default __webpack_public_path__ + "static/media/np.f6d8de21.svg";